import { useState, useEffect, useRef } from "react";
import { IoAdd, IoCash } from "react-icons/io5";
import { features } from "../constants";
import { FiMinus, FiPlus } from "react-icons/fi";

const FeatureCard = ({ features }) => {
  const sliderRef = useRef(null);
    const [scrollProgress, setScrollProgress] = useState(0);

    // Update scroll progress for tiny scrollbar indicator
    const updateScrollProgress = () => {
      if (sliderRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
        const maxScroll = scrollWidth - clientWidth;
        const progress = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
        setScrollProgress(progress);
      }
    };

    useEffect(() => {
      const container = sliderRef.current;
      if (container) {
        updateScrollProgress();
        container.addEventListener('scroll', updateScrollProgress);
        window.addEventListener('resize', updateScrollProgress);
        return () => {
          container.removeEventListener('scroll', updateScrollProgress);
          window.removeEventListener('resize', updateScrollProgress);
        };
      }
    }, [features]);

    // Handle custom scrollbar click/drag
    const handleScrollbarClick = (e) => {
      const scrollbar = e.currentTarget;
      const rect = scrollbar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const percentage = clickX / rect.width;
      
      if (sliderRef.current) {
        const { scrollWidth, clientWidth } = sliderRef.current;
        const maxScroll = scrollWidth - clientWidth;
        sliderRef.current.scrollLeft = percentage * maxScroll;
      }
    };

    return (  
      <div className="w-full py-10 ">
        {/* Cards Slider - Horizontal scroll */}
        <div
          ref={sliderRef}
          className="flex overflow-x-auto gap-2 scrollbar-thin py-4 xs:pl-10 pl-5 pr-10 scroll-smooth"
          style={{ 
            scrollbarWidth: 'thin',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch'
          }}                
        >
          {features.map((feature, index) => (
            <div
              key={feature.id || index}
              className="bg-fourth/10 border border-second shadow-md shadow-second ml-2 rounded-2xl overflow-hidden w-[360px] h-[400px] flex flex-col justify-start flex-shrink-0"
            >
              <div className="p-5">
                <div className="p-4">
                  {/* Title */}
                  <h2 className="kerning-normal text-white text-base text-mm font-bold tracking-tight leading-snug mb-2">
                    {feature.title}
                  </h2>
                  
                  {/* Subtitle */}
                  <p className="kerning-normal text-tertiary/80 text-mm font-medium tracking-tight leading-snug my-3">
                    {feature.subtitle}
                  </p>                 
                  
                  {/* Content description */}
                  <p className="kerning-normal text-tertiary/80 text-ss md:text-sm tracking-tight leading-relaxed opacity-90 line-clamp-4">
                    {feature.content}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Optional: Scroll buttons for better UX */}
        <div className="flex justify-end gap-3 p-6">
          <button 
            onClick={() => {
              if (sliderRef.current) {
                sliderRef.current.scrollBy({ left: -320, behavior: 'smooth' });
              }
            }}
            className="bg-second backdrop-blur-sm text-tertiary rounded-full p-2 transition-all duration-300 hover:scale-105"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button 
            onClick={() => {
              if (sliderRef.current) {
                sliderRef.current.scrollBy({ left: 320, behavior: 'smooth' });
              }
            }}
            className="bg-second backdrop-blur-sm text-tertiary rounded-full p-2 transition-all duration-300 hover:scale-105"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    )
};

export default FeatureCard;